import { useState, useCallback, useRef } from 'react';
import * as herdsmanManagementAction from "../../../redux/store-sarang/herdsman/herdsman-management.store";
import * as feedbackManagementAction from "../../../redux/store-sarang/feedback/feedback-management.store";
import * as userManagementAction from "../../../redux/store/user-management/user-management.store";
import ShowNotification from "../../../components/react-notifications/react-notifications";
import { NotificationMessageType } from "../../../utils/configuration";
import viVN from "../../../language/vi-VN.json";
import cleanAccents from '../../../common/replace';

export const useHerdsmanActions = (showLoading, getListHerdsmanManagement, page, rowsPerPage, orderBy, order, searchData, originPosition, setPosition) => {
    const buttonOpenAddEditRef = useRef();
    const buttonOpenConfirmRef = useRef();
    const [isOpenAddEditDialog, setOpenAddEditDialog] = useState(false);
    const [isOpenDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [isOpenActiveDialog, setOpenActiveDialog] = useState(false);
    const [isOpenDeactiveDialog, setOpenDeactiveDialog] = useState(false);
    const [isOpenUpgradeDialog, setOpenUpgradeDialog] = useState(false);
    const [isOpenDowngradeDialog, setOpenDowngradeDialog] = useState(false);
    const [isOpenCreateAccountDialog, setOpenCreateAccountDialog] = useState(false);
    const [isOpenAlertUserName, setOpenAlertUserName] = useState(false);
    const [isOpenSendMessage, setOpenSendMessage] = useState(false);
    const [isOpenBulkCreateConfirm, setOpenBulkCreateConfirm] = useState(false);
    const [isOpenAssignPermission, setOpenAssignPermission] = useState(false);
    const [bulkCreateIds, setBulkCreateIds] = useState([]);
    const [isOpenBulkCreateResult, setOpenBulkCreateResult] = useState(false);
    const [bulkCreateResult, setBulkCreateResult] = useState(null);
    const [selectedItem, setSelectedItem] = useState(null);
    const [user, setUser] = useState(null);

    const refreshList = useCallback(() => {
        let sortExpression = orderBy + ' ' + order;
        getListHerdsmanManagement(page + 1, rowsPerPage, sortExpression, searchData);
    }, [getListHerdsmanManagement, page, rowsPerPage, orderBy, order, searchData]);

    const openAddDialog = (userInfo) => {
        const userRoles = userInfo?.userRoles ? userInfo.userRoles.split(",") : [];
        if (userRoles.some(role => ["ADMIN", "HOITRUONG"].includes(role.trim())))
            setPosition(originPosition);
        else if (userRoles.some(role => ["CHIHOITRUONG"].includes(role.trim())))
            setPosition(originPosition.filter(x => x.id <= 11));
        else if (userRoles.some(role => ["DIAVUCTRUONG", "DVT_HN"].includes(role.trim())))
            setPosition(originPosition.filter(x => x.id < 10));
        else
            setPosition(originPosition.filter(x => x.id === 5 || x.id === 8));
        
        setOpenAddEditDialog(true);
        if (buttonOpenAddEditRef.current) buttonOpenAddEditRef.current.click();
    };

    const openEditDialog = (item, userInfo) => {
        const userRoles = userInfo?.userRoles ? userInfo.userRoles.split(",") : [];
        if (userRoles.some(role => ["ADMIN", "HOITRUONG"].includes(role.trim())))
            setPosition(originPosition);
        else if (userRoles.some(role => ["CHIHOITRUONG"].includes(role.trim())))
            setPosition(originPosition.filter(x => x.id <= 11));
        else if (userRoles.some(role => ["DIAVUCTRUONG", "DVT_HN"].includes(role.trim())))
            setPosition(originPosition.filter(x => x.id < 10));
        else
            setPosition(originPosition.filter(x => x.id === 5 || x.id === 8));

        setSelectedItem(item);
        setOpenAddEditDialog(true);
        if (buttonOpenAddEditRef.current) buttonOpenAddEditRef.current.click();
    };

    const closeAddEditDialog = () => {
        setOpenAddEditDialog(false);
        setSelectedItem(null);
    };

    const openSendMessageDialog = (item) => {
        setOpenSendMessage(true);
        setSelectedItem(item);
        if (buttonOpenAddEditRef.current) buttonOpenAddEditRef.current.click();
    };

    const closeSendMessageDialog = () => {
        setOpenSendMessage(false);
        setSelectedItem(null);
    };

    const openConfirmDialog = (item) => {
        setSelectedItem(item);
        if (buttonOpenConfirmRef.current) buttonOpenConfirmRef.current.click();
    };

    const closeConfirmDialog = () => {
        setOpenDeleteDialog(false);
        setOpenActiveDialog(false);
        setOpenDeactiveDialog(false);
        setOpenUpgradeDialog(false);
        setOpenDowngradeDialog(false);
        setOpenCreateAccountDialog(false);
        setOpenAlertUserName(false);
        setSelectedItem(null);
    };

    const openAssignPermissionDialog = (item) => {
        setSelectedItem(item);
        setOpenAssignPermission(true);
    };

    const closeAssignPermissionDialog = () => {
        setOpenAssignPermission(false);
        setSelectedItem(null);
    };

    const handleSubmitAddEditHerdsman = async (data) => {
        showLoading(true);
        let formData = new FormData();
        for (let key in data) {
            if (data[key] !== undefined && data[key] !== null && data[key] !== '') formData.append(key, data[key]);
        }

        try {
            let res = null;
            if (!data.id) {
                res = await herdsmanManagementAction.CreateHerdsman(formData);
            } else {
                res = await herdsmanManagementAction.UpdateHerdsman(formData);
            }
            if (res && res.content) {
                refreshList();
                ShowNotification(viVN.Success["UpdateSuccess"], NotificationMessageType.Success);
                closeAddEditDialog();
            }
        } catch (err) {
            showLoading(false);
            if (err && err.errorType) ShowNotification(viVN.Errors[err.errorType], NotificationMessageType.Error);
        } finally {
            showLoading(false);
        }
    };

    const handleSubmitSendMessage = async (data) => {
        showLoading(true);
        let formData = new FormData();
        for (let key in data) {
            if (data[key] !== undefined && data[key] !== null && data[key] !== '') formData.append(key, data[key]);
        }

        try {
            const res = await feedbackManagementAction.SendMessageToHerdsman(formData);
            if (res) {
                ShowNotification(viVN.Success["SendMessSuccess"], NotificationMessageType.Success);
                closeSendMessageDialog();
            }
        } catch (err) {
            if (err && err.errorType) ShowNotification(viVN.Errors[err.errorType], NotificationMessageType.Error);
        } finally {
            showLoading(false);
        }
    };

    const handleConfirm = async () => {
        showLoading(true);
        try {
            let userName = null;
            let res = null;

            if (isOpenDeleteDialog) {
                res = await herdsmanManagementAction.DeleteHerdsman(selectedItem.id);
            } else if (isOpenActiveDialog) {
                res = await herdsmanManagementAction.ActiveHerdsman(selectedItem.id);
            } else if (isOpenDeactiveDialog) {
                res = await herdsmanManagementAction.DeActiveHerdsman(selectedItem.id);
            } else if (isOpenUpgradeDialog) {
                res = await herdsmanManagementAction.UpgradeToSwatHerdsman(selectedItem.id);
            } else if (isOpenDowngradeDialog) {
                res = await herdsmanManagementAction.DowngradeToTDHerdsman(selectedItem.id);
            } else if (isOpenCreateAccountDialog) {
                let formData = new FormData();
                userName = cleanAccents(selectedItem.lastName).replace(/\s/g, '').toLowerCase();
                const idStr = selectedItem.id.toString();
                userName += idStr.padStart(4, '0');
                
                if (selectedItem.fullName) formData.append("FullName", selectedItem.fullName);
                formData.append("UserName", userName);
                if (selectedItem.email) formData.append("Email", selectedItem.email);
                if (selectedItem.dateOfBirth) formData.append("DateOfBirth", selectedItem.dateOfBirth);
                formData.append("Sex", !!selectedItem.gender);
                if (selectedItem.address) formData.append("Address", selectedItem.address);
                if (selectedItem.documentUploadId) formData.append("DocumentUploadId", selectedItem.documentUploadId);
                if (selectedItem.description) formData.append("Description", selectedItem.description);
                if (selectedItem.phoneNumber) formData.append("PhoneNumber", selectedItem.phoneNumber);

                formData.append("Roles[0]", "OWNER");
                if (selectedItem.groupId1 === 3 || selectedItem.groupId2 === 3)
                    formData.append("Roles[1]", "GIAOVAN");
                else if (selectedItem.groupId1 === 2 || selectedItem.groupId2 === 2)
                    formData.append("Roles[1]", "NHABEP");
                
                formData.append("HerdsmanId", selectedItem.id);
                res = await userManagementAction.CreateWithMultiRoles(formData);
            }

            if (res) {
                if (isOpenCreateAccountDialog && res.content) {
                    setUser({
                        pwd: res.content.pwd,
                        user: res.content.usr,
                    });
                    setOpenAlertUserName(true);
                }
                refreshList();
            }
            closeConfirmDialog();
        } catch (err) {
            if (err && err.errorType) ShowNotification(viVN.Errors[err.errorType], NotificationMessageType.Error);
        } finally {
            showLoading(false);
        }
    };

    const updatePermission = async (herdsmanId) => {
        try {
            const res = await herdsmanManagementAction.UpdatePermission(herdsmanId);
            if (res && res.content && res.content.status) {
                ShowNotification(viVN.Success["UpdateSuccess"], NotificationMessageType.Success);
            }
        } catch (err) {
            if (err && err.errorType) ShowNotification(viVN.Errors[err.errorType], NotificationMessageType.Error);
        }
    };

    const handleBulkCreateUsers = (ids = []) => {
        setBulkCreateIds(ids);
        setOpenBulkCreateConfirm(true);
    };

    const onConfirmBulkCreate = async () => {
        showLoading(true);
        try {
            const res = await herdsmanManagementAction.BulkCreateUsers(bulkCreateIds);
            if (res && res.content) {
                setBulkCreateResult(res.content);
                setOpenBulkCreateResult(true);
                refreshList();
            }
        } catch (err) {
            if (err && err.errorType) ShowNotification(viVN.Errors[err.errorType], NotificationMessageType.Error);
        } finally {
            showLoading(false);
            setOpenBulkCreateConfirm(false);
        }
    };

    return {
        buttonOpenAddEditRef, buttonOpenConfirmRef,
        isOpenAddEditDialog, setOpenAddEditDialog,
        isOpenDeleteDialog, setOpenDeleteDialog,
        isOpenActiveDialog, setOpenActiveDialog,
        isOpenDeactiveDialog, setOpenDeactiveDialog,
        isOpenUpgradeDialog, setOpenUpgradeDialog,
        isOpenDowngradeDialog, setOpenDowngradeDialog,
        isOpenCreateAccountDialog, setOpenCreateAccountDialog,
        isOpenAlertUserName, setOpenAlertUserName,
        isOpenSendMessage, setOpenSendMessage,
        isOpenBulkCreateConfirm, setOpenBulkCreateConfirm,
        isOpenAssignPermission, setOpenAssignPermission,
        bulkCreateIds, setBulkCreateIds,
        isOpenBulkCreateResult, setOpenBulkCreateResult,
        bulkCreateResult, setBulkCreateResult,
        selectedItem, setSelectedItem,
        user, setUser,
        openAddDialog, openEditDialog, closeAddEditDialog,
        openSendMessageDialog, closeSendMessageDialog,
        openConfirmDialog, closeConfirmDialog,
        openAssignPermissionDialog, closeAssignPermissionDialog,
        handleSubmitAddEditHerdsman, handleSubmitSendMessage,
        handleConfirm, updatePermission,
        handleBulkCreateUsers, onConfirmBulkCreate
    };
};
